const article = {
  state: {
    themeList: window.sessionStorage.getItem('themeList') ? JSON.parse(window.sessionStorage.getItem('themeList')) : [],
    currentThemeId: Number(window.sessionStorage.getItem('currentThemeId')),
    editArticleId: window.sessionStorage.getItem('editArticleId'),
    cropWidth: 6, // 裁剪的宽（rem）
    cropHeight: 4.5 // 裁剪的高（rem）
  },
  mutations: {
    SET_THEME_LIST (state, list) {
      window.sessionStorage.setItem('themeList', JSON.stringify(list))
      state.themeList = list
    },
    SET_CURRENT_THEME_ID (state, id) {
      window.sessionStorage.setItem('currentThemeId', id)
      state.currentThemeId = id
    },
    SET_THEME_EDIT_ARTICLE_ID (state, id) {
      window.sessionStorage.setItem('editArticleId', id)
      state.editArticleId = id
    }
  },
  actions: {}
}

export default article



// WEBPACK FOOTER //
// ./src/store/modules/article.js